import script from "./ExportProfilesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExportProfilesView.vue?vue&type=script&setup=true&lang=ts"

import "./ExportProfilesView.vue?vue&type=style&index=0&id=2dcd13fe&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dcd13fe"]])

export default __exports__